// global Mixin

const mixin = {
    data: function () {
        return {
            isMobApp: process.env.VUE_APP_MODE === 'mob'
        }
    },
    methods: {
        imagePath( name, format = 'png' ){
            return require('@/assets/images/' + name + "." + format);
        },
        settings(item){
            return this.$store.state.settings[item];
        }
    }
};

export default mixin;